import { transitions } from './transitions.js';

const AVAILABLE_TRANSITIONS = Object.keys(transitions);

export { AVAILABLE_TRANSITIONS };
//# sourceMappingURL=index.js.map
